import { AppBar, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import { NavLink, useLocation } from 'react-router-dom';

import ACL_PATTERN from 'constants/acl';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  height: '50px',
  backgroundColor: theme.palette.primary.main,
}));

const StyledNavLink = styled(NavLink)(({ theme, active }) => ({
  position: 'relative',
  color: theme.palette.primary.contrastText,
  margin: '0 5px',
  padding: '0 15px',
  height: '100%',
  textDecoration: 'none',
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  ...(active && {
    fontWeight: 700,
    '&::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: 0,
      right: 0,
      height: 3,
      backgroundColor: theme.palette.primary.contrastText,
    },
  }),
}));

export const TABS = [
  { label: 'Dispatch', link: '/routes', deniedPatterns: ACL_PATTERN.ASSIGNMENTS.LIST },
  { label: 'Vehicle', link: '/vehicles', deniedPatterns: ACL_PATTERN.VEHICLES.LIST },
  { label: 'Drivers', link: '/drivers', deniedPatterns: ACL_PATTERN.DRIVERS.LIST },
  { label: 'Payment', link: '/payments', deniedPatterns: [ACL_PATTERN.PAYMENTS.EVENT_LIST, ACL_PATTERN.PAYMENTS.TRANSACTION_LIST].flat() },
  { label: 'Users', link: '/users', deniedPatterns: ACL_PATTERN.USERS.USER_LIST },
];

function Navigation(props) {
  const location = useLocation();

  const { store } = props;
  const { permissionStore } = store;

  const filteredTabs = TABS.filter((tab) => permissionStore.isDenied(tab.deniedPatterns) === false);

  const isTabActive = (tab) => {
    if (location.pathname === '/' && tab.link === '/routes') {
      return true;
    }
    return location.pathname.startsWith(tab.link);
  };

  return (
    <StyledAppBar position="relative">
      <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>
        {filteredTabs.map((tab, index) => (
          <StyledNavLink
            key={`tab-${index}`}
            active={isTabActive(tab) ? 1 : 0}
            to={tab.link}
          >
            {tab.label}
          </StyledNavLink>
        ))}
      </Grid>
    </StyledAppBar>
  );
}

export default compose(inject('store'), observer)(Navigation);
